import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import * as PATH from '../../../lib/routes/path';

import WithLoading from '../../../Hoc/WithLoading';
import HeResultView from './HeResultView';

const HeResult = ({ match }) => {
  const { id } = match.params;
  const history = useHistory();

  // 초기 로딩시 id 및 token 파싱 및 저장
  useEffect(() => {
    // 목록 보기처럼 쿼리스트링 없이 들어오는 내부 이동에서도 토큰이 살아있어야 한다.
    // 다른 워크스페이스로 진입할 때만 비워서 이전 토큰이 재사용되지 않게 한다
    if (sessionStorage.getItem('be_id') !== id) {
      sessionStorage.removeItem('be_token');
    }
    // 쿠폰 목록 초기화
    sessionStorage.removeItem('preSelectedVoucherCodes');
    sessionStorage.removeItem('preSelectedVoucherCode');
    sessionStorage.setItem('be_id', id);
    const params = new URLSearchParams(window.location.search);
    params.forEach((e, i) => {
      i === 'be_token' && sessionStorage.setItem(i, e);
      i === 'profit_share' && sessionStorage.setItem(i, e);
      i === 'utm_campaign' && sessionStorage.setItem(i, e);
    });

    if (!sessionStorage.be_token) {
      alert("비정상 접근입니다. 병원에서 받은 QR 코드 또는 알림톡을 통해서 접근해 주시기 바랍니다.");
      history.push(PATH.HOME);
    }
  }, [id]);

  const getWorkspace = useMemo(() => 
    `/he/conversion/workspaces/${id}?token=${sessionStorage.be_token}`, [id]);

  return (
    <WithLoading
      component={HeResultView}
      url={getWorkspace}
      onlyLoader
    />
  );
};

export default React.memo(HeResult);
